/**
 * 이슈(어노테이션) 선택 하이라이트의 공용 토큰 (annotation-selection-feedback 스펙).
 * `fill`·`stroke` 는 2D `ANNOTATION_COLOR.SELECT` 와 3D `AnnotationSelectionHighlight` 가,
 * `markerSelectedIcon` 은 2D `FeaturesStore`·`TimeSeriesPage` 와 3D `AnnotationSelectionHighlight` 가 함께 읽는다.
 * `handle` 6개 필드를 모두 읽는 것은 3D `AnnotationSelectionHandles` 뿐이고,
 * 2D `makeSelectedFeature` 는 치수 3개(`radiusPx`·`strokeWidthPx`·`numberFontPx`)만 읽는다 —
 * 핸들 색은 2D 가 자체 값을 쓴다(테두리 `ANNOTATION_COLOR.SELECT.stroke()`, 번호 `SELECT_HANDLE_NUMBER_COLOR`).
 * 그래서 지금 2D 핸들은 검정 테두리·검정 번호(흰 외곽선), 3D 는 흰 테두리·흰 번호다. 색 통일 여부는 미결.
 */
export const ANNOTATION_SELECT_STYLE = {
  fill: "rgba(1, 1, 1, 0.4)",
  stroke: "rgb(1, 1, 1)",
  strokeWidthPx: 2,
  /** 선택된 마커의 아이콘 자산 — 2D `FeaturesStore` 의 `icon.selected` 와 같은 경로 */
  markerSelectedIcon: "/mapicon/marker-selected.svg",
  handle: {
    radiusPx: 10,
    fill: "rgb(1, 1, 1)",
    stroke: "#ffffff",
    strokeWidthPx: 2,
    numberFontPx: 15,
    numberColor: "#ffffff",
  },
} as const;
